
// 公司資料註冊頁-行業類型
export const IndustryTypeArray = [
  { titleName: "農業、林業及漁業", value: 1 },
  { titleName: "採礦及採石", value: 2 },
  { titleName: "製造", value: 3 },
  { titleName: "電力及燃氣供應", value: 4 },
  { titleName: "自來水供應；污水處理、廢棄物管理及污染防治活動", value: 5 },
  { titleName: "建造", value: 6 },
  { titleName: "進出口貿易、批發及零售業", value: 7 },
  { titleName: "運輸、倉庫、郵政及速遞服務", value: 8 },
  { titleName: "住宿及膳食服務活動", value: 9 },
  { titleName: "資訊及通訊", value: 10 },
  { titleName: "金融及保險活動", value: 11 },
  { titleName: "地產活動", value: 12 },
  { titleName: "專業、科學及技術活動", value: 13 },
  { titleName: "行政及支援服務活動", value: 14 },
  { titleName: "公共行政", value: 15 },
  { titleName: "教育", value: 16 },
  { titleName: "人類保健及社會工作活動", value: 17 },
  { titleName: "藝術、娛樂及康樂活動", value: 18 },
  { titleName: "其他服務活動", value: 19 },
  { titleName: "家庭住戶內部工作活動", value: 20 },
  { titleName: "享有治外法權的組織及團體活動", value: 21 }
];


// 求職者註冊頁-居住地區
export const DistrictArray = [
  { titleName: "中西區", value: 1 },
  { titleName: "東區", value: 2 },
  { titleName: "南區", value: 3 },
  { titleName: "灣仔區", value: 4 },
  { titleName: "九龍城區", value: 5 },
  { titleName: "觀塘區", value: 6 },
  { titleName: "深水埗區", value: 7 },
  { titleName: "黃大仙區", value: 8 },
  { titleName: "油尖旺區", value: 9 },
  { titleName: "葵青區", value: 10 },
  { titleName: "北區", value: 11 },
  { titleName: "沙田區", value: 12 },
  { titleName: "大埔區", value: 13 },
  { titleName: "荃灣區", value: 14 },
  { titleName: "屯門區", value: 15 },
  { titleName: "元朗區", value: 16 },
  { titleName: "西貹區", value: 17 },
  { titleName: "離島區", value: 18 },
];

// 求職者註冊頁-感興趣的工作類型
export const workTypeArray = [
  { titleName: "運輸及物流", value: 1 },
  { titleName: "資訊科技及通訊", value: 2 },
  { titleName: "零售及客戶服務", value: 3 },
  { titleName: "金融及專業服務", value: 4 },
  { titleName: "餐飲、酒店及旅遊", value: 5 },
  { titleName: "醫療及社會工作", value: 6 },
  { titleName: "教育及培訓", value: 7 },
  { titleName: "建造及地產", value: 8 },
  { titleName: "製造及工程", value: 9 },
  { titleName: "文化及創意產業", value: 10 },
  { titleName: "其他服務業", value: 11 },
];

// 求職者註冊頁-特殊就業需要人士類別
export const SpecialEmploymentArray = [
  { titleName: "聽力障礙", value: 1 },
  { titleName: "視力障礙", value: 2 },
  { titleName: "言語障礙", value: 3 },
  { titleName: "肢體傷殘", value: 4 },
  { titleName: "自閉症", value: 5 },
  { titleName: "精神病/情緒病", value: 6 },
  { titleName: "智能傷殘", value: 7 },
  { titleName: "器官殘障/長期病患", value: 8 },
  { titleName: "特殊學習障礙", value: 9 },
  { titleName: "注意力不足/過度活躍症", value: 10 }
];

// 工作形式
export const WorkingFormsArray = [
  { titleName: "全職", value: 1 },
  { titleName: "兼職", value: 2 },
  { titleName: "全職/兼職", value: 3 }
];

// 工作形式
export const WorkingStatusArray = [
  { titleName: "進行中", value: 0 },
  { titleName: "已暫停", value: 1 },
  { titleName: "已結束", value: 2 }
];
